/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Rareunlocks1Inputs */

const id_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembukaan langka`)
};

const ms_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukaan jarang`)
};

const da_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjældne oplåsninger`)
};

const de_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seltene Freischaltungen`)
};

const en_us2_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rare unlocks`)
};

const es_es2_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueos raros`)
};

const es_mx2_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueos raros`)
};

const fil_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga bihirang unlock`)
};

const fr_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déblocages rares`)
};

const it_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocchi rari`)
};

const hu_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritka feloldások`)
};

const nl_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeldzame ontgrendelingen`)
};

const no_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjeldne opplåsinger`)
};

const pl_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rzadkie odblokowania`)
};

const pt_br2_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueios raros`)
};

const pt_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueios raros`)
};

const ro_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deblocări rare`)
};

const fi_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harvinaiset avaukset`)
};

const sv_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sällsynta upplåsningar`)
};

const vi_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở khóa hiếm`)
};

const tr_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadir açılımlar`)
};

const cs_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vzácná odemčení`)
};

const bg_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редки отключвания`)
};

const ru_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редкие достижения`)
};

const uk_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рідкісні розблокування`)
};

const ar_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمليات فتح نادرة`)
};

const hi_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दुर्लभ अनलॉक`)
};

const th_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การปลดล็อกหายาก`)
};

const ja_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レア解除`)
};

const zh_cn2_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀有解锁`)
};

const zh_hant1_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀有解鎖`)
};

const ko_profile_library_rareunlocks1 = /** @type {(inputs: Profile_Library_Rareunlocks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`희귀 잠금 해제`)
};

/**
* | output |
* | --- |
* | "Rare unlocks" |
*
* @param {Profile_Library_Rareunlocks1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_rareunlocks1 = /** @type {((inputs?: Profile_Library_Rareunlocks1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Rareunlocks1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_rareunlocks1(inputs)
	if (locale === "ms") return ms_profile_library_rareunlocks1(inputs)
	if (locale === "da") return da_profile_library_rareunlocks1(inputs)
	if (locale === "de") return de_profile_library_rareunlocks1(inputs)
	if (locale === "en-US") return en_us2_profile_library_rareunlocks1(inputs)
	if (locale === "es-ES") return es_es2_profile_library_rareunlocks1(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_rareunlocks1(inputs)
	if (locale === "fil") return fil_profile_library_rareunlocks1(inputs)
	if (locale === "fr") return fr_profile_library_rareunlocks1(inputs)
	if (locale === "it") return it_profile_library_rareunlocks1(inputs)
	if (locale === "hu") return hu_profile_library_rareunlocks1(inputs)
	if (locale === "nl") return nl_profile_library_rareunlocks1(inputs)
	if (locale === "no") return no_profile_library_rareunlocks1(inputs)
	if (locale === "pl") return pl_profile_library_rareunlocks1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_rareunlocks1(inputs)
	if (locale === "pt") return pt_profile_library_rareunlocks1(inputs)
	if (locale === "ro") return ro_profile_library_rareunlocks1(inputs)
	if (locale === "fi") return fi_profile_library_rareunlocks1(inputs)
	if (locale === "sv") return sv_profile_library_rareunlocks1(inputs)
	if (locale === "vi") return vi_profile_library_rareunlocks1(inputs)
	if (locale === "tr") return tr_profile_library_rareunlocks1(inputs)
	if (locale === "cs") return cs_profile_library_rareunlocks1(inputs)
	if (locale === "bg") return bg_profile_library_rareunlocks1(inputs)
	if (locale === "ru") return ru_profile_library_rareunlocks1(inputs)
	if (locale === "uk") return uk_profile_library_rareunlocks1(inputs)
	if (locale === "ar") return ar_profile_library_rareunlocks1(inputs)
	if (locale === "hi") return hi_profile_library_rareunlocks1(inputs)
	if (locale === "th") return th_profile_library_rareunlocks1(inputs)
	if (locale === "ja") return ja_profile_library_rareunlocks1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_rareunlocks1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_rareunlocks1(inputs)
	return ko_profile_library_rareunlocks1(inputs)
});
export { profile_library_rareunlocks1 as "profile.library.rareUnlocks" }